export default __webpack_public_path__ + "static/2.5.2/media/diagnosticianTopUp.cfc56e4e.svg";